import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { MecanicienTabs as HubTabs } from '../components/MecanicienTabs';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import { MechanicAuthBridge } from '../../mechanic/MechanicAuthContext';
import MechanicHomePage from '../../mechanic/pages/MechanicHomePage';
import MechanicWorkOrdersPage from '../../mechanic/pages/MechanicWorkOrdersPage';
import MechanicWorkOrderDetailPage from '../../mechanic/pages/MechanicWorkOrderDetailPage';
import MechanicInspectionsPage from '../../mechanic/pages/MechanicInspectionsPage';
import MechanicMeasuresPage from '../../mechanic/pages/MechanicMaintenancePage';
import MechanicBillingPage from '../../mechanic/pages/MechanicBillingPage';
import MechanicExpensesPage from '../../mechanic/pages/MechanicExpensesPage';
import MechanicProfilePage from '../../mechanic/pages/MechanicProfilePage';
import ComplianceAuditPage from './ComplianceAuditPage';
import InventoryPage from '../../mechanic/pages/InventoryPage';

export default function MecanicienHubPage() {
  const { user, token, logout } = useAdminAuth();
  return (
    <MechanicAuthBridge user={user} token={token} logout={logout}>
      <div data-testid="mecanicien-hub">
        <HubTabs />
        <Routes>
          <Route index element={<MechanicHomePage />} />
          <Route path="bons" element={<MechanicWorkOrdersPage />} />
          <Route path="bons/:orderId" element={<MechanicWorkOrderDetailPage />} />
          <Route path="inspections" element={<MechanicInspectionsPage />} />
          <Route path="mesures" element={<MechanicMeasuresPage />} />
          <Route path="inventaire" element={<InventoryPage />} />
          <Route path="facturation" element={<MechanicBillingPage />} />
          <Route path="depenses" element={<MechanicExpensesPage />} />
          <Route path="profil" element={<MechanicProfilePage />} />
          <Route path="audit" element={<ComplianceAuditPage />} />
          <Route path="flotte" element={<Navigate to="/admin/fleet" replace />} />
          <Route path="maintenance" element={<Navigate to="/admin/maintenance" replace />} />
          <Route path="connexions" element={<Navigate to="/admin/connections" replace />} />
          <Route path="*" element={<Navigate to="/admin/mecanicien" replace />} />
        </Routes>
      </div>
    </MechanicAuthBridge>
  );
}
